import { Helmet } from 'react-helmet-async';
import { Outlet } from 'react-router-dom';
import Footer from './Footer';
import RegistrationHero from './RegistrationHero';
import { useOnboardingBeforeUnload } from '../../hooks/useOnboardingBeforeUnload';
import { useCurrentLang } from '../../hooks/useCurrentLang';

export default function Layout() {
    const lang = useCurrentLang();
    useOnboardingBeforeUnload();

    const metaData = {
        am: {
            title: 'Արդշինբանկ առցանց գրանցում',
            description:
                'Ardshinbank identity – Առցանց գրանցման հարթակ,որի միջոցով Դուք կկարողանաք առանց բանկ այցելելու դառնալ Արդշինբանկի հաճախորդ, բացել հաշիվ ու օգտվել մոբայլ բանկ ծառայություններից ☎ +374-12-222222 📧 office@ardshinbank.am',
            keywords:
                'arcanc grancum, arcanc hashvi bacum, առցանց հաշվի բացում, հաշվի բացում օնլայն, hashvi bacum online, открытие счета онлайн, mobile bank, ardshinbank online, biometric nuynakanacum, online registration, account opening, mobile app, online services, bank, Ardshinbank, online banking, mobile banking, մոբայլ բանկինգ, մոբայլ բանկ',
        },
        ru: {
            title: 'Ардшинбанк Платформа онлайн-регистрация',
            description:
                'Ardshinbank identity – Платформа онлайн-регистрации, с помощью которой вы сможете стать клиентом Ардшинбанка, открыть счет и пользоваться услугами мобильного банкинга, не посещая банк. ☎ +374-12-222222 📧 office@ardshinbank.am',
            keywords:
                'arcanc grancum, arcanc hashvi bacum, առցանց հաշվի բացում, հաշվի բացում օնլայն, hashvi bacum online, открытие счета онлайн, mobile bank, ardshinbank online, biometric nuynakanacum, online registration, account opening, mobile app, online services, bank, Ardshinbank, online banking, mobile banking, մոբայլ բանկինգ, մոբայլ բանկ',
        },
        en: {
            title: 'Ardshinbank biometric verification',
            description:
                "Ardshinbank identity - Online registration platform to become Ardshinbank's client, open an account and use mobile banking services without visiting the bank ☎ +374-12-222222 📧 office@ardshinbank.am",
            keywords:
                'arcanc grancum, arcanc hashvi bacum, առցանց հաշվի բացում, հաշվի բացում օնլայն, hashvi bacum online, открытие счета онлайн, mobile bank, ardshinbank online, biometric nuynakanacum, online registration, account opening, mobile app, online services, bank, Ardshinbank, online banking, mobile banking, մոբայլ բանկինգ, մոբայլ բանկ',
        },
    };

    return (
        <div className="flex h-dvh flex-col md:flex-row">
            <Helmet>
                <meta name="description" content={metaData[lang].description} />
                <meta name="title" content={metaData[lang].title} />
                <meta name="keywords" content={metaData[lang].keywords} />
                <title>{metaData[lang].title}</title>
            </Helmet>
            <RegistrationHero />
            <section
                id="layout-content-section"
                className="relative flex-1 flex flex-col w-full md:w-1/2 min-w-0 min-h-0 px-4 md:px-9 md:pt-10 pb-4 md:pb-9 xl:px-16 xl:pt-16 text-left"
            >
                <div id="layout-content" className="flex-1 min-h-0 flex flex-col">
                    <Outlet />
                </div>
                <Footer className="mt-4 md:mt-8 text-center" />
            </section>
        </div>
    );
}
